import scNotification, { ScNotificationProps as scNotificationProps } from './component/ScNotification'
export const ScNotification = new scNotification()

export type ScNotificationProps = scNotificationProps

